module.exports = __webpack_public_path__ + "img/s-vip.b02ca54c.jpg";